import { useEffect } from 'react'
import { isWeb } from 'tamagui'
import { useLocalSearchParams } from 'expo-router'
import { useThemeParams } from '@hooks/useThemeParams'
import { LoadingScreen } from '@components/LoadingScreen'
import { ProductPage } from '@components/ProductPage'
import { NotFoundState } from '@components/ProductPage/NotFoundState'
import { useGetProductPage } from '@services/api/graphql/queries/getProductPage'

const schoolUrl = isWeb ? window.location.hostname : ''

// Página de vendas do produto (/:slug). Servida só no web: é o nginx (flag
// members_page_product + slug-check) que roteia o path para o members.
// Sem redirect de volta ao core no 404 — evitaria loop com o roteamento.

export default function ProductSalesPage() {
  const { slug } = useLocalSearchParams<{ slug: string }>()
  const { loading: themeParamsLoading } = useThemeParams()
  const { data: product, loading } = useGetProductPage(
    schoolUrl,
    isWeb ? (slug ?? '') : '',
  )

  useEffect(() => {
    if (!isWeb || !product) return
    document.title = product.metaTitle || product.title || document.title
  }, [product])

  if (!isWeb) return <NotFoundState />

  if (loading || themeParamsLoading) return <LoadingScreen />

  if (!product) return <NotFoundState />

  return <ProductPage product={product} schoolUrl={schoolUrl} />
}
